<template>
    <!-- 票券过期延期 -->
    <div>
        <a-modal
            title="过期延期"
            :visible="visible"
            @cancel="cancel"
            :width="700"
            :destroyOnClose="true"
            class="ticket-renewal"
        >
            <a-spin :spinning="loading">
                <a-alert type="warning" show-icon>
                    <template slot="message">
                        <span class="text-color-65">该票券已过期，本次重置有效期仅作为收款记录，后续核销仍需强制核销</span>
                    </template>
                </a-alert>
                <div class="pt16">
                    <a-row class="pb16">
                        <a-col :span="12">用户票券id：<span class="text-color-45">{{ticketData.userTicketNo}}</span></a-col>
                        <a-col :span="12">票券内部名称：<span class="text-color-45">{{ticketData.name}}</span></a-col>
                    </a-row>
                    <a-row class="pb16">
                        <a-col :span="12">票券来源：<span class="text-color-45">{{ticketData.sourceCode | buyType}}</span></a-col>
                        <a-col :span="12">购买途径：<span class="text-color-45">{{(ticketData.platform == "收银台" ? ticketData.grantShopName : ticketData.platform) || '--'}}</span></a-col>
                    </a-row>
                    <a-row class="pb16">
                        <a-col :span="12">总次数：<span class="text-fail-50">{{ticketData.totalNum === -1 ? '不限' : ticketData.totalNum}}次</span></a-col>
                        <a-col :span="12">剩余可使用次数（不包含预约）：<span class="text-fail-50">{{ticketData.totalNum === -1 ? '不限' : (ticketData.totalNum - ticketData.usedNum)}}次</span></a-col>
                    </a-row>
                    <a-row>
                        使用有效期：<span class="text-fail-50">{{ticketData.validStartTime && ticketData.validStartTime.substring(0, 10)}}~{{ticketData.validEndTime && ticketData.validEndTime.substring(0, 10)}}</span>
                        <span v-if="Boolean(ticketData.delayTime)" class="text-fail">（续期截止日：{{$moment(ticketData.delayTime).format('YYYY-MM-DD')}}）</span>
                    </a-row>
                </div>
                <a-divider></a-divider>
                <a-form :form="form">
                    <a-form-item label="用户缴费金额" :label-col="{span: 6}" :wrapper-col="{span: 16}">
                        <a-input-number v-decorator="['amount', {rules: [{required: true, message: '请输入'}, {pattern: /^(\d*)([.]{1}\d{1,2}?)?$/, message: '请输入大于等于0的数字，保留小数点后两位'}]}]" style="width: 100%;"  placeholder="请输入"/>
                    </a-form-item>
                    <a-row>
                        <a-col :span="6">
                            <a-form-item class="text-right" required label="续期"></a-form-item>
                        </a-col>
                        <a-col :span="7">
                            <a-form-item>
                                <a-date-picker disabled v-decorator="['delayStartTime', {rules: [{required: true, message: '请选择'}]}]" style="width: 100%;" placeholder="请选择开始日期"/>
                            </a-form-item>
                        </a-col>
                        <a-col :span="2" class="text-center" style="line-height: 32px;">
                            ~
                        </a-col>
                        <a-col :span="7">
                            <a-form-item>
                                <a-date-picker v-decorator="['delayEndTime', {rules: [{required: true, message: '请选择'}]}]" style="width: 100%;" placeholder="请选择结束日期"/>
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <remark :form="form" :labelSpan="6" :wrapperSpan="16" operateCode="TicketDelay"></remark>
                    <shop :shops="ticketData.suitShopReserveStockConfigs" :labelSpan="6" :wrapperSpan="16"/>
                </a-form>
            </a-spin>
            <template slot="footer">
                <a-button @click="cancel" :loading="confirmLoading">取消</a-button>
                <a-button type="primary" @click="ok" :loading="confirmLoading">确定</a-button>
            </template>
        </a-modal>
        <order-pay ref="orderPay" @payCallback="callback"></order-pay>
    </div>
</template>

<script>
    import OrderPay from "@/components/modules/order/order-pay.component";
    import remark from '@/components/modules/platform/remark.component';
    import shop from '@/components/modules/platform/shop.component';
    export default {
        name: "ticketRenewal",
        components: {
            OrderPay,
            remark,
            shop
        },
        data() {
            return {
                visible: false,
                loading: false,
                confirmLoading: false,
                userTicketNo: null,
                ticketData: {},
                ticketDelayDetailData: {}
            };
        },
        props: {
        },
        methods: {
            /**
             * getDetail {method} 获取基础票券详情
             */
            getDetail() {
                this.loading = true;
                this.$api.order.detailUserTicket({
                    params: {
                        userTicketNo: this.userTicketNo
                    }
                }).then(res => {
                    if (Boolean(res.isDelay)) {
                        this.getTicketNewestDelayTime();
                    } else {
                        this.loading = false;
                        this.form.setFieldsValue({
                            delayStartTime: this.$moment(this.$moment().format("YYYY-MM-DD 00:00:00"))
                        });
                    }
                    this.ticketData = res;
                });
            },
            /**
             * getTicketNewestDelayTime {method} 获取基础票券详情
             */
            getTicketNewestDelayTime() {
                this.$api.order.getTicketNewestDelayTime({
                    params: {
                        userTicketNo: this.userTicketNo
                    }
                }).then(res => {
                    let { delayEndTime } = res;
                    if (delayEndTime) {
                        this.form.setFieldsValue({
                            delayStartTime: this.$moment(delayEndTime).add(1, "seconds")
                        });
                    } else {
                        this.form.setFieldsValue({
                            delayStartTime: this.$moment(this.$moment().format("YYYY-MM-DD 00:00:00"))
                        });
                    }
                    this.loading = false;
                    this.ticketDelayDetailData = res;
                });
            },

            /**
             * open 打开弹窗
             */
            open(userTicketNo) {
                this.visible = true;
                this.userTicketNo = userTicketNo;
                this.getDetail();
            },
            /**
             * cancel 关闭弹窗
             */
            cancel() {
                this.visible = false;
                this.ticketData = {};
            },
            /**
             * ok 确认延期
             */
            ok() {
                if (this.confirmLoading === true) {
                    return false;
                }
                this.form.validateFields((errors, values) => {
                    if (Boolean(errors)) {
                        return false;
                    }
                    values.delayStartTime = values.delayStartTime.format("YYYY-MM-DD HH:mm:ss");
                    values.delayEndTime = values.delayEndTime.format("YYYY-MM-DD 23:59:59");
                    let shop = JSON.parse(values.shop);
                    values.shopId = shop.shopId;
                    values.shopName = shop.shopName;
                    delete values.shop;
                    this.confirmLoading = true;
                    this.$api.order.userTicketOperateDelay({
                        body: {
                            ...values,
                            phone: this.ticketData.phone,
                            userId: this.ticketData.userId,
                            userTicketNo: this.userTicketNo
                        }
                    }).then(res => {
                        this.$refs.orderPay.orderId = res;
                        this.$refs.orderPay.userId = this.ticketData.userId;
                        this.visible = false;
                        this.confirmLoading = false;
                        setTimeout(() => {
                            this.$refs.orderPay.visiblePayOrder = true;
                        }, 300)
                    }).catch(err => {
                        this.confirmLoading = false;
                    });
                })

            },
            /**
             * callback 确认延期
             */
            callback() {
                setTimeout(() => {
                    this.$emit('callback');
                }, 500);
            }
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
            this.loginInfo = this.$userInfoTool.getUser();
        },
        created() {},
        updated() {},
        mounted() {

        }
    };
</script>

<style lang="scss">
    .ticket-renewal {
        .ant-modal-footer {
            border-top: 1px solid #e8e8e8!important;
        }
    }
</style>
